import { render, staticRenderFns } from "./stfxPage.vue?vue&type=template&id=b1b397a4&"
import script from "./stfxPage.vue?vue&type=script&lang=js&"
export * from "./stfxPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports